import React from 'react'

import {
  Box,
  Display,
  FlexDirection,
  JustifyContent,
  AlignItems,
  Image,
  Text,
  FontWeight,
  Color,
  colors,
  BorderStyle,
  Space,
} from '@gousto-internal/citrus-react'
import { useDispatch } from 'react-redux'

import { ExplanationBoxData, ExplanationBoxType } from './data'
import { ExplanationBoxContent, ConnectionLine } from './styled'

type ExplanationBoxProps = ExplanationBoxData & {
  order: number
}

export const ExplanationBox = ({
  title,
  icon,
  text,
  type,
  order,
  trackingAction,
}: ExplanationBoxProps) => {
  const dispatch = useDispatch()
  const isPickYourRecipesBox = type === ExplanationBoxType.PICK_YOUR_RECIPES

  const onClickExplanationBox = () => {
    dispatch(trackingAction())
  }

  return (
    <Box
      style={{ alignSelf: order % 2 === 0 ? 'flex-end' : 'flex-start', position: 'relative' }}
      onClick={onClickExplanationBox}
    >
      <Box
        data-testid={isPickYourRecipesBox ? 'PickYourRecipesBox' : 'ExplanationBox'}
        width={['262px', '436px']}
        borderRadius={1.5}
        borderStyle={isPickYourRecipesBox ? undefined : BorderStyle.Solid}
        borderWidth={0.5}
        borderColor={Color.ColdGrey_100}
        style={{ zIndex: 2 }}
      >
        <ExplanationBoxContent
          bgColor={colors[Color.Secondary_300]}
          isPickYourRecipes={isPickYourRecipesBox}
        >
          <Box style={{ zIndex: 2 }}>
            <Box
              width="100%"
              display={Display.Flex}
              flexDirection={FlexDirection.Row}
              justifyContent={JustifyContent.FlexStart}
              alignItems={AlignItems.Center}
            >
              <Image alt={title} src={icon} width="28px" height="28px" />
              <Space size={1} direction="horizontal" />
              <Text
                fontWeight={FontWeight.SemiBold}
                size={2}
                color={isPickYourRecipesBox ? Color.White : Color.ColdGrey_900}
              >
                {title}
              </Text>
            </Box>
            <Text size={1} color={isPickYourRecipesBox ? Color.White : Color.ColdGrey_900}>
              {text}
            </Text>
          </Box>
        </ExplanationBoxContent>
      </Box>
      {order !== 5 && (
        <ConnectionLine color={colors[Color.ColdGrey_200]} directionLeft={order % 2 === 0} />
      )}
    </Box>
  )
}
